import { supabaseClient } from '../net/supabase-client.js?v=20260801-token-hash-1';

async function rpc(name, args) {
  const { data, error } = await supabaseClient.rpc(name, args);
  if (error) throw error;
  return data;
}

export async function getAdminContext() {
  const data = await rpc('current_admin_context', {});
  return data && typeof data === 'object' ? data : { is_admin: false, role: 'player', capabilities: [] };
}

export async function searchAdminUsers(query = '', limit = 25) {
  const data = await rpc('admin_search_users', { p_query: query, p_limit: limit });
  return Array.isArray(data) ? data : [];
}

export async function adminModerateUser(userId, action, durationMinutes = 60, reason = '', requestId = crypto.randomUUID()) {
  return rpc('admin_moderate_user', {
    p_user_id: userId,
    p_action: action,
    p_duration_minutes: durationMinutes,
    p_reason: reason,
    p_request_id: requestId,
  });
}

export async function adminCreateGameNotice(recipientId, body, kind = 'warning', durationHours = 48, requestId = crypto.randomUUID()) {
  return rpc('admin_create_game_notice', {
    p_recipient_id: recipientId,
    p_body: body,
    p_kind: kind,
    p_duration_hours: durationHours,
    p_request_id: requestId,
  });
}

export async function listAdminChatHistory(channel = null, query = '', limit = 200, before = null) {
  const data = await rpc('admin_list_chat_history', {
    p_channel: channel,
    p_query: query,
    p_before: before,
    p_limit: limit,
  });
  return Array.isArray(data) ? data : [];
}

export async function listAdminAuditLog(targetUserId = null, limit = 20) {
  const data = await rpc('admin_list_audit_log', {
    p_target_user_id: targetUserId,
    p_limit: limit,
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchMyGameNotices(limit = 20) {
  const data = await rpc('list_my_game_notices', { p_limit: limit });
  return Array.isArray(data) ? data : [];
}

export async function markGameNoticeRead(noticeId) {
  return rpc('mark_game_notice_read', { p_notice_id: noticeId });
}
